<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="DeleteHub-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="DeleteHub-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="DeleteHub-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="DeleteHub-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="DeleteHub-st2" d="M67.79,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H67.79c-3.05,0-5.53-2.47-5.53-5.53V38.68C62.26,35.63,64.73,33.16,67.79,33.16z"/>
            <path class="DeleteHub-st3" d="M32.33,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H32.33c-3.05,0-5.53-2.47-5.53-5.53V38.68C26.8,35.63,29.28,33.16,32.33,33.16z"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.DeleteHub_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.DeleteHub_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="DeleteHub-button lxn-margin-auto lxn-w100">
      <CustomButton @click="DeleteHub" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.DeleteHub_button}}
      </CustomButton>
    </div>
    <div class="DeleteHub-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next2" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
        {{$store.getters.language.texts.DeleteHub_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'


export default {
  name: 'DeleteHub',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.$route.params.hubUUID);
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    DeleteHub: function () {
      this.$store.commit('setAppBusy', true);
      var nodeCount = this.$store.state.nodes.length;
      for(var i = nodeCount - 1; i >= 0; i--){
        if(this.$store.state.nodes[i].hubUUID == this.hub.uuid){
          this.$store.commit('deleteNode', i);
        }
      }
      var widgetCount = this.$store.state.widgets.length;
      for(i = widgetCount - 1; i >= 0; i--){
        if(this.$store.state.widgets[i].hubUUIDs == undefined){
          if(this.$store.state.widgets[i].hubUUID == this.hub.uuid){
            this.$store.commit('deleteWidget', i);
          }
        }else{
          if(this.$store.state.widgets[i].hubUUIDs.indexOf(this.hub.uuid) != -1){
            this.$store.commit('deleteWidget', i);
          }
        }
      }
      this.$store.commit('deleteHub', this.hub.index);
      this.$store.commit('saveState');
      this.$router.push('/DeleteDeviceSuccess');
      this.$store.commit('setAppBusy', false);
    },
    next2: function () {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
  .DeleteHub-topCurve-wrapper {
    height: 200px;
  }
  .DeleteHub-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .DeleteHub-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.DeleteHub-st0 {
    fill: #ECECEC;
  }
	.DeleteHub-st1 {
    fill: #53636C;
  }
	.DeleteHub-st2 {
    fill: #1EA5DE;
  }
	.DeleteHub-st3 {
    fill: #F36C4F;
  }
</style>
